
export const agencyCertificateSelector = (
  agencies,
  selectedAgency,
  setSelectedAgency,
  agencyLabelMessage = ''
) => {
  return (
    <div className="tgbl-user-earned-accreditations__list__item__print-form-inner tgbl-flex tgbl-flex--wrap tgbl-flex--density-15">
      <div className="tgbl-user-earned-accreditations__list__item__print-form__content">
        <input type="hidden" name="print_pdf" value="1"/>
        <input type="hidden" name="earned_accreditation_id" value={agencies[selectedAgency].earned_accreditation_id}/>
        {Object.keys(agencies).length > 1 &&
          <label>{agencyLabelMessage}
            <select
              value={selectedAgency}
              onChange={i => setSelectedAgency(i.target.value)}
            >
              {Object.keys(agencies).sort().map(agency_id => <option key={agency_id} value={agency_id}>
                {agencies[agency_id].agency_name}
              </option>)}
            </select>
          </label>
        }
      </div>
      <input className="tgbl-button tgbl-button--theme-primary tgbl-button--size-sm" type="submit" value="Download Certificate"/>
    </div>
  );
};
